import { render } from "./AccountModule.vue?vue&type=template&id=c1dc5cc8"
import script from "./AccountModule.vue?vue&type=script&lang=ts"
export * from "./AccountModule.vue?vue&type=script&lang=ts"

import "../../assets/scss/modules/account.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script